export { default as enemyDefeated } from "./enemyDefeated";
